<template>
  <div class="performance-container">
    <div class="header-container">
      <h2 class="title">考核规则管理</h2>
      <el-button
        v-if="isSuperUser"
        type="primary"
        icon="el-icon-plus"
        @click="handleAddRule"
        class="new-rule-btn"
      >
        新建规则
      </el-button>
    </div>

    <div class="mobile-container" v-if="isMobile">
      <mobile-card v-for="item in mobileRows" :key="item.id" :rows="item.rows">
        <div>
          <el-tag
            v-if="item.isTemplate"
            size="mini"
            type="success"
            class="mobile-template-tag"
          >
            <i class="el-icon-folder-opened"></i> 模板
          </el-tag>
          <el-button
            v-if="canDeleteRule(item)"
            size="mini"
            type="danger"
            @click="handleDelete(item)"
            >删除</el-button
          >
          <el-button
            v-if="canEditRule(item)"
            size="mini"
            @click="handleEdit(item)"
            >编辑</el-button
          >
          <el-button v-if="!item.isTemplate || isSuperUser" size="mini" @click="handleLaunchAssessment(item)">发起考核</el-button>
          <el-button size="mini" type="primary" @click="handleRowClick(item)"
            >详情</el-button
          >
        </div>
      </mobile-card>
    </div>

    <!-- the pc table -->
    <div class="table-container" v-if="!isMobile">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 180px)"
        :show-header="true"
        :header-cell-style="{
          background: '#f5f7fa',
          border: 'none',
          color: '#909399',
        }"
        :cell-style="{ borderBottom: '1px solid #EBEEF5', borderRight: 'none' }"
        @row-click="handleRowClick"
      >
        <el-table-column prop="name" label="绩效规则名称" width="280">
          <template slot-scope="scope">
            <div class="rule-info">
              <span class="rule-name" style="color: #409eff">{{
                scope.row.name
              }}</span>
              <el-tag
                v-if="scope.row.isTemplate"
                size="mini"
                type="success"
                class="template-tag"
              >
                <i class="el-icon-folder-opened"></i> 模板
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="updateTime" label="更新时间" width="220">
          <template slot-scope="{ row }">
            {{ formatDate(row.updateTime) }}
          </template>
        </el-table-column>

        <el-table-column prop="userName" label="创建人" width="180">
        </el-table-column>

        <el-table-column prop="depart" label="部门" width="220">
        </el-table-column>

        <el-table-column label="发起考核" width="180">
          <template slot-scope="{ row }">
            <div
              class="launch-assessment"
              v-if="!row.isTemplate"
              @click.stop="handleLaunchAssessment(row)"
            >
              <img src="@/assets/plane.png" class="plane-icon" />
              <span class="launch-text">发起考核</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="280">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click.stop="handleRowClick(row)"
            >
              <i class="el-icon-view"></i> 详情
            </el-button>
            <el-button
              v-if="canDeleteRule(row)"
              type="text"
              size="small"
              @click.stop="handleDelete(row)"
            >
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div
        class="pagination-container"
        style="margin-top: 15px; text-align: right"
      >
        <el-pagination
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
          :current-page="pageParams.pageNum"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageParams.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 规则编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :fullscreen="isMobile"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>

        <el-form-item label="考核人员" prop="assessmentUsers">
          <el-cascader
            v-model="ruleForm.assessmentUsers"
            :options="avaiableUsersForRule"
            :props="cascaderProps"
            :show-all-levels="false"
            placeholder="请选择考核人员"
            @change="handleEmployeeChange"
            filterable
            clearable
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="不参与考核人员" prop="excludedUsers">
          <div style="margin-bottom: 8px; color: #ff0000; font-size: 14px">
            提示：将从已选部门的考核人员中剔除以下人员
          </div>
          <el-cascader
            v-model="ruleForm.excludedUsers"
            :options="excludeUsersForRule"
            :props="cascaderProps"
            :show-all-levels="false"
            placeholder="请选择不参与考核人员"
            @change="handleExcludedEmployeeChange"
            filterable
            clearable
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 发起考核表单 -->
    <el-dialog
      title="发起新的考核计划"
      :fullscreen="isMobile"
      :visible.sync="assessmentDialogVisible"
      width="50%"
    >
      <el-form
        :model="assessmentForm"
        :rules="assessmentRules"
        ref="assessmentForm"
        label-width="120px"
      >
        <el-form-item label="计划名称" prop="planName">
          <el-input
            v-model="assessmentForm.planName"
            placeholder="请输入计划名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="考核周期" prop="year">
          <el-row :gutter="24" style="display: flex; align-items: flex-start">
            <el-col :span="12" style="padding-right: 12px">
              <div class="period-label">年份</div>
              <el-select v-model="assessmentForm.year" placeholder="选择年份">
                <el-option
                  v-for="year in yearOptions"
                  :key="year"
                  :label="year + '年'"
                  :value="year"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="12" style="padding-right: 12px">
              <div class="period-label">月份</div>
              <el-select v-model="assessmentForm.month" placeholder="选择月份">
                <el-option
                  v-for="month in monthOptions"
                  :key="month"
                  :label="month + '月'"
                  :value="month"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="考核规则" prop="ruleId">
          <el-select
            v-model="assessmentForm.ruleId"
            placeholder="选择考核规则"
            @change="handleRuleChange"
          >
            <el-option
              v-for="rule in allPlans"
              :key="rule.id"
              :label="rule.name"
              :value="rule.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考核人员">
          <el-input
            v-model="currentUserName"
            class="launch-assessor-input"
            disabled
            placeholder="当前登录用户"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assessmentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAssessment">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Role } from "@/constants/Role";
import { profileMixin } from "@/mixins/profileMixin";
import { responsiveMixin } from "@/mixins/responsiveMixin";
import { launchPerformancePlan } from "@/request/performance_request";
import {
  canDeleteRule as canDeleteRuleByState,
  canEditRule as canEditRuleByState,
  getLaunchableRules,
} from "@/utils/rulePermission";
import MobileCard from "./MobileCard.vue";

// 移除所有未使用的导入
export default {
  name: "PerformanceRule",
  components: {
    MobileCard,
  },
  mixins: [responsiveMixin, profileMixin],
  data() {
    return {
      tableData: [],
      pageParams: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页条数
        total: 0, // 总条数
      },
      dialogVisible: false,
      dialogTitle: "新建考核规则",
      assessmentDialogVisible: false,
      ruleForm: {
        id: null,
        name: "",
        assessmentUsers: [],
        excludedUsers: [],
      },
      assessmentForm: {
        planName: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      departmentUserOptions: [],
      selectedEmployees: [],
      yearOptions: Array.from(
        { length: 5 },
        (_, i) => new Date().getFullYear() - 2 + i
      ),
      monthOptions: Array.from({ length: 12 }, (_, i) => i + 1),
      cascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
      },
      rules: {
        name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        assessmentUsers: [
          { required: true, message: "请选择考核人员", trigger: "blur" },
        ],
      },
      assessmentRules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
        ],
      },
      allPlans: [],
      isAdmin: false,
      meId: "",
      isLoading: false,
      submitTimer: null,
    };
  },
  computed: {
    avaiableUsersForRule() {
      const filterNodes = (nodes) => {
        return nodes
          .map((node) => {
            if (node.children && node.children.length > 0) {
              const filteredChildren = filterNodes(node.children);
              if (filteredChildren.length > 0) {
                return { ...node, children: filteredChildren };
              }
            } else if (this.isEmpId(node.id) && node.role === Role.USER) {
              return {
                ...node,
                disabled: this.ruleForm.excludedUsers.some(
                  (item) => item === node.id
                ),
              };
            }
            return null;
          })
          .filter((node) => node !== null);
      };
      const filtered = filterNodes(this.departmentUserOptions);
      return filtered;
    },
    excludeUsersForRule() {
      const filterNodes = (nodes) => {
        return nodes
          .map((node) => {
            if (node.children && node.children.length > 0) {
              const filteredChildren = filterNodes(node.children);
              if (filteredChildren.length > 0) {
                return { ...node, children: filteredChildren };
              }
            } else if (this.isEmpId(node.id)) {
              return node;
            }
            return null;
          })
          .filter((node) => node !== null);
      };
      const filtered = filterNodes(this.departmentUserOptions);
      return filtered;
    },
    filteredDepartmentUserOptions() {
      const filterNodes = (nodes) => {
        return nodes
          .map((node) => {
            if (node.children && node.children.length > 0) {
              const filteredChildren = filterNodes(node.children);
              if (filteredChildren.length > 0) {
                return { ...node, children: filteredChildren };
              }
            } else if (this.isEmpId(node.id)) {
              return node;
            }
            return null;
          })
          .filter((node) => node !== null);
      };
      const filtered = filterNodes(this.departmentUserOptions);
      return filtered;
    },
    mobileRows() {
      return this.tableData.map((item) => ({
        ...item,
        rows: [
          { label: "规则名称", value: item.name },
          { label: "创建人", value: item.userName },
          { label: "部门", value: item.depart },
          { label: "更新时间", value: this.formatDate(item.updateTime) },
        ],
      }));
    },
    isSuperUser() {
      return this.role === 'super';
    },
    currentUserName() {
      return this.$store.getters['user/getUserName'] || "";
    },
  },
  mounted() {
    // 初始化员工数据
    this.fetchEmployeeData();
    // 查询考核规则
    this.searchRules();
    this.fetchAllPlans();
  },
  methods: {
    async fetchAllPlans() {
      const res = await this.$http.get("/rule/listAll");
      this.allPlans = getLaunchableRules(res.data);
    },
    canEditRule(row) {
      return canEditRuleByState(row, this.isSuperUser);
    },
    canDeleteRule(row) {
      return canDeleteRuleByState(row, this.isSuperUser);
    },
    resetAssessmentForm() {
      const userId = this.$store.getters['user/getUserId'];
      this.assessmentForm = {
        planName: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        assessmentUsers: userId ? [`emp_${userId}`] : [],
      };
    },
    async searchRules() {
      try {
        const response = await this.$http.get("/rule/pageSearch", {
          params: this.pageParams, // 传递分页参数（pageNum、pageSize）
        });
        // 检查响应体中的code字段而不是HTTP状态码
        if (response && response.data && response.data.code === "200") {
          const resultData = response.data.data; // 注意这里需要两层data
          this.pageParams.total = resultData.total || 0;
          this.tableData = resultData.records || [];
        } else {
          console.warn(
            "搜索考核规则失败，响应code:",
            response?.data?.code || "未知"
          );
        }
      } catch (error) {
        console.error("搜索考核规则时发生错误:", error);
      }
    },
    async fetchEmployeeData() {
      try {
        const response = await this.$http.get("/getUserTree");
        // 修改判断条件，更灵活地处理不同类型的响应数据
        if (response && response.status === 200) {
          if (Array.isArray(response.data) && response.data.length > 0) {
            this.departmentUserOptions = response.data;
          } else if (
            typeof response.data === "object" &&
            response.data !== null
          ) {
            // 如果是对象，可能需要根据实际结构进行调整
            if (response.data.data && Array.isArray(response.data.data)) {
              this.departmentUserOptions = response.data.data;
            } else {
              this.departmentUserOptions = response.data;
            }
          } else {
            console.warn(
              "员工数据接口返回空数据或格式不符合预期:",
              response.data
            );
          }
        } else {
          console.warn(
            "员工数据接口返回状态异常:",
            response ? response.status : "无响应"
          );
        }
      } catch (error) {
        console.error("获取员工数据失败:", error);
        console.error("错误详情:", error.response || error.message);
        // 移除throw error，让所有错误由main.js中的响应拦截器统一处理
      }
    },
    isDeptId(id) {
      return typeof id === "string" && id.startsWith("dept_");
    },
    // 工具方法：通过映射表判断是否为员工
    isEmpId(id) {
      return typeof id === "string" && id.startsWith("emp_");
    },
    // 工具方法：提取原始ID（去除前缀，用于后续业务提交）
    getOriginalId(id) {
      if (this.isDeptId(id)) return id.replace("dept_", "");
      if (this.isEmpId(id)) return id.replace("emp_", "");
      return id;
    },
    handleRowClick(row) {
      this.$router.push({
        name: "AssessmentTable",
        params: { ruleId: row.id, ruleName: row.name },
      });
    },
    async handleRuleChange() {
      try {
        if (!this.assessmentForm.ruleId) {
          return;
        }
        console.log("获取规则详情，ruleId:", this.assessmentForm.ruleId);
        const response = await this.$http.get("/rule/getForEdit", {
          params: { ruleId: this.assessmentForm.ruleId },
        });
        console.log("规则详情响应:", response);

        if (!(response && response.data && response.data.code === "200")) {
          this.$message.error(
            "获取规则详情失败：" + (response?.data?.msg || "未知错误")
          );
        }
      } catch (error) {
        console.error("获取规则详情时发生错误:", error);
        this.$message.error("获取规则详情失败");
      }
    },
    handleAddRule() {
      this.dialogTitle = "新建考核规则";
      this.ruleForm = {
        id: null,
        name: "",
        assessmentUsers: [],
        excludedUsers: [],
      };
      this.dialogVisible = true;
    },
    handleEmployeeChange(value) {
      this.rawAssessmentSelections = value || [];
      if (this.rawAssessmentSelections.length === 0) {
        this.ruleForm.assessmentUsers = [];
        return;
      }
      // 1. 筛选部门ID和员工ID（基于前缀）
      const selectedDeptIds = this.rawAssessmentSelections.filter((id) =>
        this.isDeptId(id)
      );
      const selectedEmpIds = this.rawAssessmentSelections.filter((id) =>
        this.isEmpId(id)
      );
      // 2. 收集部门下的员工ID（需处理带前缀的子节点ID）
      const deptEmpIds = [];
      const collectEmpIds = (nodes) => {
        nodes.forEach((node) => {
          if (this.isEmpId(node.id)) {
            deptEmpIds.push(node.id); // 直接收集带前缀的员工ID
          } else if (node.children && node.children.length > 0) {
            collectEmpIds(node.children);
          }
        });
      };
      selectedDeptIds.forEach((deptId) => {
        const deptNode = this.findNodeById(this.departmentUserOptions, deptId);
        if (deptNode && deptNode.children) {
          collectEmpIds(deptNode.children);
        }
      });
      // 3. 合并员工ID（去重，仅保留带前缀的员工ID）
      let finalEmpIds = [...new Set([...selectedEmpIds, ...deptEmpIds])];
      // 4. 剔除与不考核人员的冲突（逻辑不变，基于带前缀ID对比）
      if (this.ruleForm.excludedUsers.length > 0) {
        finalEmpIds = finalEmpIds.filter(
          (empId) => !this.ruleForm.excludedUsers.includes(empId)
        );
      }
      // 5. 更新考核人员（带前缀ID，提交时需转原始ID）
      this.ruleForm.assessmentUsers = finalEmpIds;
    },
    // 发起考核人员选择
    handleLaunchEmployeeChange(value) {
      this.rawAssessmentSelections = value || [];
      if (this.rawAssessmentSelections.length === 0) {
        this.assessmentForm.assessmentUsers = [];
        return;
      }
      // 1. 筛选部门ID和员工ID（基于前缀）
      const selectedDeptIds = this.rawAssessmentSelections.filter((id) =>
        this.isDeptId(id)
      );
      const selectedEmpIds = this.rawAssessmentSelections.filter((id) =>
        this.isEmpId(id)
      );
      // 2. 收集部门下的员工ID（需处理带前缀的子节点ID）
      const deptEmpIds = [];
      const collectEmpIds = (nodes) => {
        nodes.forEach((node) => {
          if (this.isEmpId(node.id)) {
            deptEmpIds.push(node.id); // 直接收集带前缀的员工ID
          } else if (node.children && node.children.length > 0) {
            collectEmpIds(node.children);
          }
        });
      };
      selectedDeptIds.forEach((deptId) => {
        const deptNode = this.findNodeById(this.departmentUserOptions, deptId);
        if (deptNode && deptNode.children) {
          collectEmpIds(deptNode.children);
        }
      });
      // 3. 合并员工ID（去重，仅保留带前缀的员工ID）
      let finalEmpIds = [...new Set([...selectedEmpIds, ...deptEmpIds])];
      // 5. 更新考核人员（带前缀ID，提交时需转原始ID）
      this.assessmentForm.assessmentUsers = finalEmpIds;
    },
    handleExcludedEmployeeChange(value) {
      // 1. 处理原始选择值（空值时重置）
      const selectedTempValues = value || [];
      this.ruleForm.excludedUsers = []; // 先重置，避免脏数据
      // 2. 筛选不考核人员中的部门ID（dept_前缀）和员工ID（emp_前缀）
      const selectedDeptIds = selectedTempValues.filter((id) =>
        this.isDeptId(id)
      );
      const selectedEmpIds = selectedTempValues.filter((id) =>
        this.isEmpId(id)
      );
      // 3. 收集所有部门下的员工ID（递归处理子部门，确保全量员工被选中）
      const deptEmpIds = [];
      // 递归函数：遍历部门节点的子节点，收集员工ID
      const collectDeptEmpIds = (nodes) => {
        nodes.forEach((node) => {
          // 若子节点是员工，直接收集；若是子部门，继续递归
          if (this.isEmpId(node.id)) {
            deptEmpIds.push(node.id);
          } else if (
            this.isDeptId(node.id) &&
            node.children &&
            node.children.length > 0
          ) {
            collectDeptEmpIds(node.children);
          }
        });
      };
      // 遍历选中的部门ID，收集其下所有员工
      selectedDeptIds.forEach((deptId) => {
        const deptNode = this.findNodeById(this.departmentUserOptions, deptId);
        if (deptNode && deptNode.children && deptNode.children.length > 0) {
          collectDeptEmpIds(deptNode.children);
        }
      });
      // 4. 合并员工ID（去重，仅保留员工ID，排除部门ID）
      const finalExcludedEmpIds = [
        ...new Set([...selectedEmpIds, ...deptEmpIds]),
      ];
      this.ruleForm.excludedUsers = finalExcludedEmpIds;
      // 5. 从考核人员中剔除不考核人员（核心逻辑）
      if (this.rawAssessmentSelections.length > 0) {
        // 重新计算考核人员的原始范围（基于考核人员的原始选择）
        const assessmentDeptIds = this.rawAssessmentSelections.filter((id) =>
          this.isDeptId(id)
        );
        const assessmentEmpIds = this.rawAssessmentSelections.filter((id) =>
          this.isEmpId(id)
        );
        // 收集考核人员原始选择中所有部门下的员工
        const assessmentDeptEmpIds = [];
        const collectAssessmentEmpIds = (nodes) => {
          nodes.forEach((node) => {
            if (this.isEmpId(node.id)) {
              assessmentDeptEmpIds.push(node.id);
            } else if (
              this.isDeptId(node.id) &&
              node.children &&
              node.children.length > 0
            ) {
              collectAssessmentEmpIds(node.children);
            }
          });
        };
        assessmentDeptIds.forEach((deptId) => {
          const deptNode = this.findNodeById(
            this.departmentUserOptions,
            deptId
          );
          if (deptNode && deptNode.children && deptNode.children.length > 0) {
            collectAssessmentEmpIds(deptNode.children);
          }
        });
        // 合并考核人员原始范围（部门员工+直接选的员工）
        let finalAssessmentEmpIds = [
          ...new Set([...assessmentDeptEmpIds, ...assessmentEmpIds]),
        ];
        // 剔除不考核人员
        finalAssessmentEmpIds = finalAssessmentEmpIds.filter(
          (empId) => !finalExcludedEmpIds.includes(empId)
        );
        // 6. 更新考核人员最终值，处理空值场景
        this.ruleForm.assessmentUsers = finalAssessmentEmpIds;
        if (finalAssessmentEmpIds.length === 0) {
          // 若所有考核人员被排除，重置状态
          this.rawAssessmentSelections = [];
          this.ruleForm.excludedUsers = [];
          this.$message.info("所有考核人员已被排除，已清空选择");
        }
      }
    },
    handlePageChange(newPageNum) {
      this.pageParams.pageNum = newPageNum;
      this.searchRules(); // 重新加载当前页数据
    },
    handlePageSizeChange(newPageSize) {
      this.pageParams.pageSize = newPageSize;
      this.pageParams.pageNum = 1; // 重置为第一页
      this.searchRules();
    },
    findNodeById(nodes, targetId) {
      for (const node of nodes) {
        if (node.id === targetId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeById(node.children, targetId);
          if (found) return found;
        }
      }
      return null;
    },
    async handleEdit(row) {
      if (!this.canEditRule(row)) {
        this.$message.warning("该模板已进入审批流程，暂不可修改。如需调整，请由主管打回后再修改。");
        return;
      }
      this.dialogTitle = "编辑考核规则";
      try {
        const response = await this.$http.get("/rule/getForEdit", {
          params: { ruleId: row.id },
        });
        if (response.status === 200 && response.data.code === "200") {
          const ruleData = response.data.data;
          if (
            ruleData.assessmentUserIds &&
            Array.isArray(ruleData.assessmentUserIds)
          ) {
            const assessmentUserIdsWithPrefix = ruleData.assessmentUserIds.map(
              (userId) => `emp_${userId}`
            );
            this.ruleForm = {
              id: ruleData.id,
              name: ruleData.name,
              assessmentUsers: assessmentUserIdsWithPrefix, // 带前缀的ID，用于回显
              excludedUsers: [], // 不参与考核人员可根据业务补充回显逻辑
            };
            this.rawAssessmentSelections = assessmentUserIdsWithPrefix;
            this.dialogVisible = true;
          } else {
            console.error(
              "assessmentUserIds不是有效数组:",
              ruleData.assessmentUserIds
            );
            this.$message.error("获取规则数据失败：考核人员信息格式错误");
          }
        } else {
          console.error("接口返回非200状态码:", response.status);
          this.$message.error(
            "获取规则数据失败：" + (response.data?.msg || "未知错误")
          );
        }
      } catch (error) {
        console.error("编辑规则时发生异常:", error);
        this.$message.error("编辑失败：" + (error.message || "未知错误"));
      }
    },
    handleDelete(row) {
      if (!this.canDeleteRule(row)) {
        this.$message.warning("该模板已创建考核计划，不能删除。");
        return;
      }
      this.$confirm("确认删除该考核规则吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const response = await this.$http.get("/rule/deleteRule", {
              params: { ruleId: row.id }, // 传递规则ID
            });
            const data = response.data
            console.log("🚀 ~ data:", data)
            if (data.code === '200') {
              this.$message.success(data.msg || "删除成功");
              this.fetchAllPlans()
              this.searchRules()
            } else {
              this.$message.error(data.msg || "删除失败");
            }
          } catch (error) {
            console.error("删除规则失败：", error);
            this.$message.error("删除失败，请检查网络或联系管理员");
          }
        })
        .catch(() => {
          // pass
        });
    },
    async handleLaunchAssessment(row) {
      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      this.assessmentDialogVisible = true;

      if (!this.isAdmin) {
        this.assessmentForm = {
          ruleId: row.id,
          assessmentUsers: [`emp_${this.uid}`],
          planName: row.name,
          year: year,
          month: month,
        };
        return;
      }
      try {
        const response = await this.$http.get("/rule/getForEdit", {
          params: { ruleId: row.id },
        });
        if (response && response.data) {
          const ruleData = response.data;
          // 添加防御性检查，确保assessmentUserIds存在且是数组
          const assessmentUserIdsWithPrefix = Array.isArray(
            ruleData.assessmentUserIds
          )
            ? ruleData.assessmentUserIds.map((userId) => `emp_${userId}`)
            : [];
          this.assessmentForm = {
            ruleId: row.id,
            assessmentUsers: assessmentUserIdsWithPrefix,
            planName: row.name,
            year: year,
            month: month,
          };
        } else {
          this.$message.error("获取规则数据失败：响应格式异常");
        }
      } catch (error) {
        console.error("发起考核失败:", error);
        this.$message.error("发起考核失败，请稍后重试");
      }
    },
    getOriginalAssessmentUserIds() {
      return this.ruleForm.assessmentUsers
        .map((id) => {
          // 调用原有工具方法，去除emp_前缀，返回数字类型ID
          return Number(this.getOriginalId(id));
        })
        .filter((id) => !isNaN(id)); // 过滤无效ID
    },
    async submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const loginUser = this.$store.getters['user/getUserId'];
          const requestParams = {
            id: this.ruleForm.id,
            name: this.ruleForm.name,
            creator: loginUser, // 创建人ID（user.id）
            assessmentUserIds: this.getOriginalAssessmentUserIds(), // 考核人员ID列表
          };
          let response;
          if (this.dialogTitle === "新建考核规则") {
            response = await this.$http.post("/rule/addRule", requestParams);
          } else {
            response = await this.$http.post("/rule/update", requestParams);
          }
          if (response.status === 200) {
            this.$message.success(response.data.msg || "操作成功");
            this.dialogVisible = false;
            this.searchRules(); // 重新加载分页数据
          } else {
            this.$message.error(
              "操作失败:" + (response.data.msg || "未知错误")
            );
          }
        }
      });
    },
    submitAssessment() {
      if (this.isLoading) return; // 防止重复触发
      if (this.submitTimer) {
        clearTimeout(this.submitTimer);
      }
      this.submitTimer = setTimeout(() => {
        this.runSubmitAssessment();
      }, 300);
    },
    runSubmitAssessment() {
      if (this.isLoading) return;
      this.$refs.assessmentForm.validate(async (valid) => {
        if (valid) {
          this.isLoading = true;
          try {
            const creator = this.$store.getters['user/getUserId'];
            const executorIds = creator ? [Number(creator)] : [];

            // Validate executorIds before calling the API
            if (!executorIds || executorIds.length === 0) {
              this.$message.error("考核人员列表不能为空");
              return;
            }

            const requestData = {
              planName: this.assessmentForm.planName,
              year: this.assessmentForm.year.toString(),
              month: this.assessmentForm.month.toString(),
              creator: creator,
              ruleId: this.assessmentForm.ruleId,
              executorIds: executorIds,
            };
            const response = await launchPerformancePlan(requestData);
            const { data: { code, msg } = {} } = response;
            if (!(code === 200 || code === "200")) {
              this.$message.error("发起考核计划失败: " + (msg || "未知错误"));
              return;
            }
            this.assessmentDialogVisible = false;
            this.resetAssessmentForm();
            this.$message.success("考核计划已发起");
          } catch (error) {
            console.error("发起考核计划时发生错误:", error);
            this.$message.error("发起考核计划失败");
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.performance-container {
  padding: 20px;
  height: 100%;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  color: #303133;
  margin: 0;
}

.new-rule-btn {
  height: 40px;
}

.table-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.rule-info {
  display: flex;
  align-items: center;
}

.rule-name {
  cursor: pointer;
}

.launch-assessment {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
}

.plane-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.period-label {
  margin-bottom: 5px;
  font-size: 14px;
  color: #606266;
}

.launch-assessor-input {
  width: 198px;
}

.template-tag {
  margin-left: 8px;
  font-size: 12px;
}

.mobile-template-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}
</style>
